import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zag-card-body',
  templateUrl: './zag-card-body.component.html',
  styleUrl: './zag-card-body.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZagCardBodyComponent {}
